import React from 'react';
import GlobalStyle from './theme/GlobalStyle';
import SessionTimeoutAlert from './components/auth/SessionTimeoutAlert';
import ErrorBoundary from './pages/error/ErrorBoundaryPage';
import AppRoutes from './routes/optimized';
import { Toaster } from 'react-hot-toast';
import './utils/logger'; // 콘솔 로그 제어

function App() {
  return (
    <>
      <GlobalStyle />
      <ErrorBoundary>
        <AppRoutes />
      </ErrorBoundary>
      {/* 세션 타임아웃 경고 */}
      <SessionTimeoutAlert warningMinutes={5} />
      {/* Toast 컨테이너 */}
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 3000,
          style: {
            fontSize: '14px',
            fontFamily: "'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif",
          },
        }}
      />
    </>
  );
}

export default App;
